import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-text-short-description-config',
  templateUrl: './text-short-description-config.component.html',
  styleUrls: ['./text-short-description-config.component.scss'],
})
export class AtwTextShortDescriptionConfig implements OnInit {
  @Input() objectChoosing: any;
  @Input() class: any;
  @Input() device: any; 
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any;

  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false,
  };
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  styles_field = [
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'nen_bieu_tuong',
      index: 3,
    },
    {
      title: 'dieu_chinh_vien',
      index: 4,
    },
    {
      title: 'nen_bieu_tuong',
      index: 5,
    },
  ];
  classUpdates = {
    "text": {
      "width": "163px",
      "height": "57px",
      "overflow-y": "auto",
      "transition": "0.2s"
    },
    "text__editor": {
      "font-size": "16px",
      "line-height": "1.5"
    },
    "read-more": {
      "position": "relative",
      "text-align": "center",
      "margin-top": "10px",
      "display": "flex",
      "justify-content": "center"
    },
    "read-more__blur": {
      "position": "absolute",
      "bottom": "100%",
      "left": "0",
      "width": "100%",
      "height": "150px",
      "pointer-events": "none",
      "visibility": "visible",
      "opacity": "1",
      "transition": "0.3s"
    },
    "+read-more__button": {
      "position": "relative",
      "color": "#007bff",
      "cursor": "pointer",
      "background-color": "transparent",
      "font-size": "16px",
      "font-style": "normal",
      "width": "50%",
      "height": "30px",
      "border-left-width": "0px",
      "border-bottom-right-radius": "0px",
      "border-color": "black",
      "border-top-width": "0px",
      "gap": "2px",
      "border-right-width": "0px",
      "border-bottom-width": "0px",
      "box-shadow": "none",
      "border-top-right-radius": "0px",
      "align-items": "center",
      "justify-content": "center",
      "border-top-left-radius": "0px",
      "border-bottom-left-radius": "0px",
      "border-style": "solid",
      "flex-direction": "row",
      "display": "flex",
      "margin-bottom": "10px",
      "margin-top": "0px"
    },
    "+read-more__button-content": {
      "white-space": "pre-wrap",
      "letter-spacing": "1px",
      "font-family": "Arial",
      "font-weight": "bold",
      "overflow": "hidden",
      "line-height": "1.5",
      "word-break": "break-word",
      "text-align": "center",
      "background-color": "transparent",
      "text-transform": "uppercase",
      "font-size": "16px",
      "text-decoration": "none"
    },
    "+read-more__icon-wrapper": {
      "color": "#000000",
      "z-index": "1",
      "font-size": "18px"
    },
    "+read-more__icon": {
      "justify-content": "center",
      "align-items": "center",
      "width": "100%",
      "font-size": "inherit",
      "display": "flex"
    },
    "-read-more__button": {
      "position": "relative",
      "color": "#007bff",
      "cursor": "pointer",
      "background-color": "transparent",
      "font-size": "16px",
      "font-style": "normal",
      "width": "150px",
      "height": "30px",
      "border-left-width": "0px",
      "border-bottom-right-radius": "0px",
      "border-color": "black",
      "border-top-width": "0px",
      "gap": "2px",
      "border-right-width": "0px",
      "border-bottom-width": "0px",
      "box-shadow": "none",
      "border-top-right-radius": "0px",
      "align-items": "center",
      "justify-content": "center",
      "border-top-left-radius": "0px",
      "border-bottom-left-radius": "0px",
      "border-style": "solid",
      "flex-direction": "row",
      "display": "flex",
      "margin-bottom": "10px"
    },
    "-read-more__button-content": {
      "white-space": "pre-wrap",
      "letter-spacing": "1px",
      "font-family": "Arial",
      "font-weight": "bold",
      "overflow": "hidden",
      "line-height": "1.5",
      "word-break": "break-word",
      "text-align": "center",
      "background-color": "transparent",
      "text-transform": "uppercase",
      "font-size": "16px",
      "text-decoration": "none"
    },
    "-read-more__icon-wrapper": {
      "color": "#000000",
      "z-index": "1",
      "font-size": "18px"
    },
    "-read-more__icon": {
      "justify-content": "center",
      "align-items": "center",
      "width": "100%",
      "font-size": "inherit",
      "display": "flex"
    }
  };
  configUpdates = {
    "animation-selected": { id: '000000' },
    "-webkit-scrollbar": {
      "width": "10px",
      "background-color": "#e7e7e7",
      "thumb-background-color": "#666666",
      "border-radius": "8px"
    },
    "view-type": {
      "overflow-y": "auto",
      "isOpen": false,
      "blur_background_color": "#ffffff",
      "+button_box_shadow": {
        "is_box_shadow": false,
        "property_box_shadow": {
          "type": "outset",
          "h-offset": 1,
          "v-offset": 1,
          "blur": 1,
          "spread": 1,
          "color": "#ffffffff"
        }
      },
      "-button_box_shadow": {
        "is_box_shadow": false,
        "property_box_shadow": {
          "type": "outset",
          "h-offset": 1,
          "v-offset": 1,
          "blur": 1,
          "spread": 1,
          "color": "#ffffffff"
        }
      },
      "+flex-direction": {
        "flex_row": "row",
        "flex_row_reverse": "row-reverse",
        "flex_row_column_reverse": "column-reverse",
        "icon_disable": false,
        "flex_row_column": "column",
        "icon_name": "search"
      },
      "-flex-direction": {
        "flex_row": "row",
        "flex_row_reverse": "row-reverse",
        "flex_row_column_reverse": "column-reverse",
        "icon_disable": false,
        "flex_row_column": "column",
        "icon_name": "search"
      }
    }
  };
  staticdataUpdates = {
    "desktop_animation_type": "none",
    "tablet_portrait_animation_type": "none",
    "tablet_landscape_animation_type": "none",
    "mobile_portrait_animation_type": "none",
    "mobile_landscape_animation_type": "none",
    "desktop_animation": {
      "animation-0": {}
    },
    "tablet_portrait_animation": {
      "animation-0": {}
    },
    "tablet_landscape_animation": {
      "animation-0": {}
    },
    "mobile_portrait_animation": {
      "animation-0": {}
    },
    "mobile_landscape_animation": {
      "animation-0": {}
    },
    "+content_vn": "Xem thêm",
    "-content_vn": "Rút gọn"
  };
  customize = [];
  effect_hover = [];
  effect_hover_data: any = {};
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator:VhEventMediator,
    public functionService: FunctionService,
    private http: HttpClient,
  ) { }


  ngOnInit() {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    // Một số key-name chưa có trên class sẽ được thêm vào 
    for (const key in this.classUpdates) {
      if (!this.class.hasOwnProperty(key)) {
        this.class[key] = this.classUpdates[key];
      }
    }

    for (const key in this.configUpdates) {
      if (!this.config.hasOwnProperty(key)) {
        this.config[key] = this.configUpdates[key];
      }
    }

    for (const key in this.staticdataUpdates) {
      if (!this.staticdata.hasOwnProperty(key)) {
        this.staticdata[key] = this.staticdataUpdates[key];
      }
    }

    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/short-description.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })
  }

  ngOnChanges(changes: any): void {
    this.config.padding_bottom ??= {};
    this.config.padding_bottom.p ??= "0px";
    
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  /**
   * Lấy ra fieldName class dùng để chứa con trỏ
   */
  get getClassNameCursor() {
    if (this.objectChoosing.component == 'AtwDescriptionRecruitment') {
      return 'description-recruitment'
    }
    return 'text';
  }

  /**
   * Cập nhật giá trị Kiểu hiển thị cho phần tử text-short-description
   * 
   * @description
   * Nếu là 'visible' thì set height của phần tử là 100%
   * Nếu là 'read-more' thì set height của phần tử là chiều cao của nội dung
   * Nếu là 'auto' thì set height của phần tử là chiều cao của nội dung
   * 
   * @returns {void}
   */
  updateTypeDisplay(){
    if (this.config['view-type']['overflow-y'] == 'visible') {
      this.class['text']['overflow-y'] = 'visible';
      this.class['text']['height'] = '100%';
    } else if (this.config['view-type']['overflow-y'] == 'read-more') {
      if (!this.config['view-type'].hasOwnProperty('isOpen')) this.config['view-type']['isOpen'] = false;
      if (!this.config['view-type'].hasOwnProperty('blur_background_color')) this.config['view-type']['blur_background_color'] = '#fff';

      const element = document.getElementById(this.objectChoosing._id);
      
      this.class['text']['overflow-y'] = this.config['view-type']['isOpen'] ? 'visible' : 'hidden';
      this.class['text']['height'] = this.config['view-type']['isOpen'] ? `${element.scrollHeight}px` : `${this.config?.dimension?.height}px` || '100%';
      this.class['text']['transition'] = '0.3s';
    } else {
      this.class['text']['overflow-y'] = this.config['view-type']['overflow-y'];
      this.class['text']['height'] = `${this.config?.dimension?.height}px` || '100%';
    }

    this.updateClass();
    this.updateConfig();
  }


  /**
   * Hàm update config vào database.
   */
   updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    })
    .then((bool: any) => {
      
    });
  }

  /**
  *Hàm update class vào database.
  */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }
  
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['text']['width'] = event.width + 'px';
    if (event.height) this.class['text']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0]);
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
